const StorStructureLabels = {
    identitaSegnalante: {
        label: "Identità segnalante",
        persFisicaSegnalante: {
            label: "Persona fisica incaricata di effettuare la segnalazione",
            fields: {
                nome: "Nome",
                cognome: "Cognome",
                posPrezzoSegnalante: "Posizione",
                numeroProtocolloSegnalante: "Numero di Protocollo del segnalante"
            }
        },
        datiAnagraficiSegnalante: {
            label: "Dati anagrafici del soggetto segnalante",
            fields: {
                nomeSoggettoSegnalante: "Nome soggetto segnalante",
                tipoSoggettoSegnalante: "Tipo soggetto segnalante",
                formaGiuridica: "Forma giuridica",
                codiceLEI: "Codice LEI",
                via: "Via",
                codPostale: "Codice postale",
                numCivico: "Numero civico",
                nazione: "Nazione",
                regione: "Città",
                provincia: "Provincia",
            }
        },
        vesteSegnalante: {
            label: "Veste segnalante",
            fields: {
                vesteSegnalante: "Veste",
                catTipologiaNegoziazione: "Tipo di attività",
                catTipologiaStrumNegoziato: "Tipo di strumento negoziato",
                relazioneConSoggSegnalato: "Tipo di relazione con soggetto segnalato"
            }
        },
        referenteRichiestaMaggioriInfo: {
            label: "Referente/i",
            fields: {
                nomeReferente: "Nome",
                cognomeReferente: "Cognome",
                indirizzoMailReferente: "Indirizo Email",
                numCellulare: "Cellulare",
                numTelefono: "Telefono",
                posizioneReferente: "Posizione"
            }
        }
    },
    descrizioneNaturaSospetto: {
        label: "Descrizione natura sospetto",
        motiviSospetto: {
            label: "Motivi del sospetto (max 2500 caratteri)",
            fields: {
                motiviSospetto: "Motivi"
            }
        },
        naturaSospetto: {
            label: "Natura del sospetto",
            fields: {
                natura: "Natura"
            }
        }
    },
    identitaDelSospettato: {
        label: "Identità del sospettato",
        informazioniPersonali: {
            label: "Informazioni personali e generali",
            fields: {
                attivitaAltriSoggettiImplicati: "Attività degli altri soggetti implicati",
                codicePostale: "Codice postale",
                cognome: "Cognome / Codice Cliente",
                dataInizioRelazioneProfessionale: "Data inizio relazione professionale",
                dataNascita: "Data di nascita",
                entitaPortafoglioSospettato: "Entità portafoglio sospettato",
                formaGiuridica: "Forma giuridica",
                identificativoCliente: "Identificativo cliente",
                localita: "Località",
                luogo: "Luogo",
                modelliNegoziazioneSospettato: "Modelli di negoziazione del sospettato",
                naturaInterventoSospettato: "Natura dell'intervento del sospettato",
                nome: "Nome / Codice Aderente",
                nomeAltriSoggettiImplicati: "Nome altri soggetti implicati (max 200 caratteri)",
                numeroCivico: "Numero civico",
                numeroConto: "Numero conto",
                numeroIdentificativoNazionale: "Numero identificativo nazionale (Codice fiscale/nazionale o codice LEI)",
                posizione: "Posizione",
                posizioneSospettato: "Posizione sospettato",
                provincia: "Provincia",
                regione: "Regione",
                relazioneConEmittenteStrumFinanziari: "Relazione con l'emittente degli strumenti finanziari",
                nazione: "Nazione",
                tipoAttivitaUnitaNegozazione: "Tipo di attività dell'unità di negoziazione",
                via: "Via"
            }
        }
    },
    informazioniSupplementariGenerali: {
        label: "Informazioni supplementari generali",
        informazioniSupplementari: {
            label: "Informazioni supplementari",
            fields: {
                noteAggiuntive: "Note aggiuntive",
                iniziativeControSoggettoSegnalato: "Iniziative nei confronti del soggetto segnalato",
            }
        }
    },
    ordineOperazione: {
        label: "Ordine / Operazione",
        descrStrumFinanziario: {
            label: "Descrizione dello strumento finanziario",
            fields: {
                codIdentificatoSottostante: "Codice identificativo sottostante",
                codiceIdentificativo: "Codice identificativo",
                codiceSedeNegoziazione: "Codice sede negoziazione",
                condizioneContrattuali: "Condizioni contrattuali",
                dataScadenza: "Data scadenza",
                descrOperSospette: "Descrizione delle operazioni sospette",
                dimensione: "Dimensione",
                fuoriSede: "Fuori sede",
                importoNominale: "Importo nominale",
                margine: "Margine",
                nomeCompletoODesc: "Nome completo o descrizione",
                nomeCompleto: "Nome completo o descrizione sottostante",
                nomeSedeNegoziazione: "Nome sede negoziazione",
                pagamentoAnticipato: "Pagamento anticipato",
                premio: "Premio",
                prezzoEsercizio: "Prezzo esercizio",
                tassoInteresse: "Tasso interesse",
                tipoCodiceCFI: "Tipo codice CFI",
                tipoCodiceCFISottostante: "Tipo codice CFI sottostante",
                tipoDerivatoOTC: "Tipo derivato OTC",
                valoreNominale: "Valore nominale",
                valutaDenominazionePrezzo: "Valuta della denominazione del prezzo"
            }
        },
        nazione: {
            label: "Luogo (Nazione)",
            fields: {
                codiceStrumFinanaziario: "Codice identificativo",
                nomeCodiceStatoDoveImpartitoOrdine: "Nome e codice stato dove è stato impartito l'ordine",
                nomeCodiceStatoDoveEseguitoOrdine: "Nome e codice stato dove è stato eseguito l'ordine"
            }
        },
        dataOraOrdine: {
            label: "Data e ora dell'ordine",
            fields: {
                codiceStrumFinanaziario: "Codice identificativo",
                dataFine: "Data fine",
                dataInizio: "Data inizio",
                oraInizio: "Ora inizio",
                oraFine: "Ora fine",
                fusoOrario: "Fuso orario"
            }
        },
        descrizioneOrdine: {
            label: "Descrizione dell'ordine",
            fields: {
                codiceStrumFinanaziario: "Codice identificativo",
                descrOperSospette: "Descrizione delle operazioni sospette",
                dataRegolamento: "Data regolamento",
                identitaPersonaCheCancellaOrdine: "Identità della persona che ha modificato o cancellato l'ordine",
                identitaPersonaCheInoltraOrdine: "Identità della persona che ha effettivamente modificato l'ordine",
                identitaPersonaCheRiceveOrdine: "Identità della persona che ha effettivamente ricevuto l'ordine",
                mezzoPerModificaOrdine: "Mezzo usato per modificare l'ordine",
                mezzoTrasmissioneOrdine: "Mezzo di trasmissione dell'ordine",
                modalitaInoltroOrdine: "Modalità di inoltro dell'ordine",
                naturaDellaModifica: "Natura della modifica",
                numeroRiferimentoOrdine: "Numero di riferimento dell'ordine",
                oraInoltroOrdine: "Orario di inoltro dell'ordine",
                oraModificaCancellazione: "Orario della modifica o cancellazione",
                oraRegolamento: "Ora regolamento",
                prezzoAcquistoVendita: "Prezzo di acquisto/vendita",
                tipoOrdine: "Tipo di ordine",
                volumeQuantitaStrumentiFinanziari: "Volume/quantità di strumenti finanziari",
                descrizioneOrdine: "Descrizione dell'ordine (max 2500 caratteri)"
            }
        }
    },
    documentazioneAllegata: {
        label: "Documentazione allegata",
        documentiAllegati: {
            label: "Documenti allegati",
            fields: {
                documento: "Documento"
            }
        }
    }
}



export default StorStructureLabels;
